import { useRouteError } from "react-router-dom";
import NavigationBar from './Components/NavigationBar';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <>
      <NavigationBar />
      <section className="App-header">
        <p>
          <h1>Oops!</h1>
          <p>Sorry, an unexpected error has occurred.</p>
        </p>
      </section>
      
    </>
  );
}